<!-- eslint-disable max-len -->
<template>
  <v-expand-x-transition>
    <v-dialog v-model='dialog' persistent width='800'>
      <template v-slot:activator='{ on, attrs }'>
        <v-btn rounded small depressed color='primary' class='ma-1' v-bind='attrs' v-on='on'>Download Data</v-btn>
      </template>

      <v-card>
        <v-sheet color='#1867c0'>
          <v-card-title class='modal-header'>Download Data</v-card-title>
        </v-sheet>
        <v-container style='padding: 0 15px;margin-bottom:15px;'>
          <v-card-title>Data Range</v-card-title>
          <v-card-subtitle>Select a date range to extract data from</v-card-subtitle>
          <v-row>
            <v-col cols='12' sm='12' md='6'>
              <v-menu ref='menu1' v-model='menu1' :close-on-content-click='false' transition='scale-transition' offset-y
                min-width='auto'>
                <template v-slot:activator='{ on, attrs }'>
                  <v-text-field class="modal-pad" v-model='dateFormatted1' label='Start Date'
                    prepend-icon='mdi-calendar' v-bind='attrs' v-on='on' readonly></v-text-field>
                </template>
                <v-date-picker v-model='fromDate' @input='menu1 = false'></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols='12' sm='12' md='6'>
              <v-menu ref='menu2' v-model='menu2' :close-on-content-click='false' transition='scale-transition' offset-y
                min-width='auto'>
                <template v-slot:activator='{ on, attrs }'>
                  <v-text-field class="modal-pad" v-model='dateFormatted2' label='End Date' prepend-icon='mdi-calendar'
                    v-bind='attrs' v-on='on' readonly></v-text-field>
                </template>
                <v-date-picker v-model='toDate' @input='menu2 = false'></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row v-if="displayToggle">
            <v-container class='switchControl'>
              <v-switch v-model='trafficSurveyToggle' style='color:black;' class="modal-pad" hide-details>
                <template v-slot:label>
                  <span class='input__label'>Traffic Survey Data</span>
                </template>
              </v-switch>
              <div>
                <span class='light-hint  modal-pad'>Check to include traffic survey data</span>
              </div>
            </v-container>
          </v-row>
          <v-row style="margin-top:15px;">
            <v-col cols='12'>
              <h4 class="modal-pad">Summary of selected data</h4>
            </v-col>
            <v-col v-if="networkProvider">
              <span class='light-hint modal-pad'>Area</span>
              <h5 class="modal-pad">{{ networkProvider }}</h5>
            </v-col>
            <v-col v-if="localAuthority">
              <span class='light-hint'>Provider</span>
              <h5>{{ localAuthority }}</h5>
            </v-col>
            <v-col v-show="location">
              <span class='light-hint'>Location</span>
              <h5>{{ location }}</h5>
            </v-col>
            <!-- <v-col v-show="apiCount">
            <span class='light-hint'>Number of Datasets</span>
            <h5>{{apiCount}}</h5>
          </v-col> -->
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-col class='disclaimer' cols='8'>
            <h4>Disclaimer</h4>
            <p>
              Volumes of downloads will increase the time to resolve individual files.
              Please take this into consideration when selecting a large range to
              produce your results. {{ singular }}
            </p>
          </v-col>
          <v-spacer></v-spacer>
          <v-btn depressed @click='dialog = false'>Cancel</v-btn>
          <v-btn depressed color='primary' @click='download(fromDate, toDate, type, singular); dialog = false'>
            Download</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-expand-x-transition>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    networkProvider: String,
    localAuthority: String,
    location: String,
    download: Function,
    displayToggle: Boolean,
    type: String,
    singular: Boolean,
  },
  data() {
    return {
      id: 'Modal',
      dialog: false,
      fromDate: new Date().toISOString().substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
    };
  },
  computed: {
    dateFormatted1() {
      return this.formatDate(this.fromDate);
    },
    dateFormatted2() {
      return this.formatDate(this.toDate);
    },
    trafficSurveyToggle: {
      get() {
        return this.$store.state.map2.downloadTrafficSurveyToggle;
      },
      set(val) {
        this.$store.commit('setDownloadTrafficSurveyToggle', val);
      },
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY') : '';
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
};
</script>

<style lang="scss">
.modal-header {
  justify-content: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.5em;
}

.light-hint {
  color: rgba(0, 0, 0, 0.6);
}

.input__label {
  color: black;
  font-weight: bold;
  font-size: 1em;
}

.switchControl {
  font-size: 16px;
}

.modal-pad {
  padding: 0 16px;
  margin: 0 !important;
}

.disclaimer {
  font-size: 16px;

  h4 {
    font-size: 1em;
  }

  p {
    font-size: 0.8em;
  }
}
</style>
